export enum ProductKey {
  Sheds = 'shedview',
  Carports = 'carportview',
}
